import { useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'

export type PageHeadersCtx = {
  setTitle: (title: string) => void
  setSubTitle: (subtitle: string) => void
}

export const usePageHeaders = (title: string, subtitle = '') => {
  const { setTitle, setSubTitle } = useOutletContext<PageHeadersCtx>()

  useEffect(() => {
    setTitle(title)
    setSubTitle(subtitle)
  }, [title, subtitle, setTitle, setSubTitle])
}
